/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Ui_Weather_Wind_Mostly_CrossInputs */

const en_ui_weather_wind_mostly_cross = /** @type {(inputs: Ui_Weather_Wind_Mostly_CrossInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wind ${i?.range} · mostly crosswind`)
};

const de_ui_weather_wind_mostly_cross = /** @type {(inputs: Ui_Weather_Wind_Mostly_CrossInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wind ${i?.range} · meist Seitenwind`)
};

/**
* | output |
* | --- |
* | "Wind {range} · mostly crosswind" |
*
* @param {Ui_Weather_Wind_Mostly_CrossInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_wind_mostly_cross = /** @type {((inputs: Ui_Weather_Wind_Mostly_CrossInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Wind_Mostly_CrossInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_wind_mostly_cross(inputs)
	return de_ui_weather_wind_mostly_cross(inputs)
});